// extracted by mini-css-extract-plugin
export default {"stilling":"dhsgM1GJd-stilling","fadeIn":"dhsggCSrH-fadeIn","stilling__content":"dhsgLHusY-stilling__content","stillingContent":"dhsgLHusY-stilling__content"};